export const T = {
  en_GB: {
    title: "Personal AI Settings",
    onlyVisibleToYou: "Only visible to you",
    back: "Back",
    sections: {
      prompts: {
        label: "Chat Prompts",
        description: "Customize the suggested prompts shown in new chats.",
      },
      playground: {
        label: "Tool Playground",
        description: "Test individual AI tools with custom inputs.",
      },
      mcp: {
        label: "MCP Servers",
        description: "Connect external Model Context Protocol servers.",
      },
      imap: { label: "IMAP", description: "Read-only mailbox access for AI tools." },
    },
  },
  nb_NO: {
    title: "Personlige AI-innstillinger",
    onlyVisibleToYou: "Bare synlig for deg",
    back: "Tilbake",
    sections: {
      prompts: {
        label: "Chat-forslag",
        description: "Tilpass forslagene som vises i nye chatter.",
      },
      playground: {
        label: "Verktøytesting",
        description: "Test enkeltverktøy for AI med egne inndata.",
      },
      mcp: {
        label: "MCP-servere",
        description: "Koble til eksterne Model Context Protocol-servere.",
      },
      imap: { label: "IMAP", description: "Lesetilgang til e-postkassen for AI-verktøy." },
    },
  },
} as const;
